import { LuChevronUp } from 'react-icons/lu';

import { withStroke } from '../../utils/withStroke';

const ChevronUpIcon = withStroke(LuChevronUp);

export { ChevronUpIcon };
